import React, { useState } from "react";
import Table from "../UserDashboard/Table";
import SideBar from "./SideBar";
import { toast } from "react-hot-toast";
import { Empty } from "../UserDashboard/Notifications/Error";
import { useDispatch, useSelector } from "react-redux";
// import {
//   deleteAllOrdersAction,
//   getAllOrdersAction,
// } from '../../Redux/Actions/OrderAction';
// import { Loader } from '../../components/Notifications/Loader';
import BigLoader from "../UserDashboard/Notifications/BigLoader";
import orderData from "./data";
import bookingApi from "../../api/booking/BookingApi";
import { useEffect } from "react";
import Loading from "../../Util/Loading";
import ProcessingBar from "../../Util/Processingbar";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";

function BookingList() {
  const dispatch = useDispatch();
  const [booking, setBooking] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { user } = useSelector((state) => state.user || {});

  const getAllBookings = async () => {
    try {
      const { response, err } = await bookingApi.getAllBookings();

      if (response && response.data) {
        setBooking(response.data);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!user) return null;

      setIsLoading(true);
      await Promise.all([getAllBookings()]);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!user) {
      dispatch(setAuthModalOpen(true));
    }
  }, [user, dispatch]);

  if (!user) return null;

  {
    console.log({ booking });
  }

  // // delete all orders
  const deleteAllOrdersHandler = () => {
    if (window.confirm("All orders will be deleted")) {
      // dispatch(deleteAllOrdersAction());
      alert("delete all");
    }
  };

  const loading = false;
  const error = false;
  const orders = booking?.booking;
  const total = orderData?.total;
  const pending = orderData?.pending;
  const completed = orderData?.completed;
  const cancelled = orderData?.cancelled;

  const deleteLoading = false;

  if (isLoading) {
    return <Loading />;
  }

  return (
    <SideBar>
      {loading ? (
        <div className="flex-colo h-96">
          <Loading />
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          <div className="flex justify-between items-center gap-2">
            <h2 className="text-xl font-bold">Booked History</h2>
            {/* {orders?.length > 0 && (
              <button
                disabled={deleteLoading}
                onClick={deleteAllOrdersHandler}
                className="bg-flash font-medium text-white py-2 px-6 rounded"
              >
                {deleteLoading ? <ProcessingBar /> : "Delete All"}
              </button>
            )} */}
          </div>

          {orders?.length === 0 ? (
            <div className="flex-colo h-96">
              <Empty text={"No booking found"} />
            </div>
          ) : (
            <Table
              datas={Array.isArray(orders) ? orders : []}
              dashboard={true}
            />
          )}
        </div>
      )}
    </SideBar>
  );
}

export default BookingList;
